import React from "react";
import EmotionCube3D from "./EmotionCube3D";
import SectionHeader from "./SectionHeader";

const ResearchSection = () => {
  return (
    <section
      id="research"
      className="py-16 sm:py-24 md:py-32 px-4 sm:px-6 bg-[#FAEDE7] relative overflow-hidden"
    >
      <div className="relative max-w-7xl mx-auto">
        <SectionHeader
          eyebrow="Interactive Visualization"
          title="Interactive 3D"
          titleAccent="Emotion Space"
          subtitle="Experience emotions in a 3D interactive environment with particle systems and real-time visualization of emotional states."
          index={5}
          className="mb-12 sm:mb-16"
        />

        <EmotionCube3D />
      </div>
    </section>
  );
};

export default ResearchSection;
